// generated
export const GATEWAY_VERSION = "0.19.0";
